import React, { useRef, useState, useEffect } from 'react';
import { StyleSheetManager } from 'styled-components';


// оборачивает все стили в указанный айдишник
// например делает #widgetId .className { ... } вместо .className { ... }
// нужно чтобы глобальные стили обернутые в #widgetId не переопределяли местные стили
const ReactWidgetStyleManager = ({ children, widgetId }) => {
  const containerRef = useRef(null);
  const [isMounted, setIsMounted] = useState(false);

  const addWidgetIdPlugin = function(context, content, parent) {
    if (!widgetId) return content;
    if (context == -2) {
      const parentClassName = parent[0];
      if (parentClassName) {
        const newContent = `
          ${content.replaceAll(parentClassName, `#${widgetId} ${parentClassName}`)}
          ${content.replaceAll(parentClassName, `[class^="ant-"] ${parentClassName}`)}
        `;
        return newContent;
      }
    }

    return content;
  };

  // Name the plugin
  Object.defineProperty(addWidgetIdPlugin, 'name', {
    value: 'add-widget-id-plugin'
  });

  useEffect(() => {
    if (containerRef.current) {
      setIsMounted(true);
    }
  }, []);

  return (
    <div id={`${widgetId}-inner`} ref={containerRef}>
      {isMounted ? (
        <StyleSheetManager
          stylisPlugins={[addWidgetIdPlugin]}
          target={document.getElementById(widgetId)}
        >
          {children}
        </StyleSheetManager>
      ) : (
        <div>{children}</div>
      )}
    </div>
  );
};

export default ReactWidgetStyleManager;
